import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  generalTab: {
    description: 'Tab name on the Store Setup Page for managing General Store Settings',
    defaultMessage: 'General',
    id: '8vn2cd',
  },
  checkoutRatesTab: {
    description: 'Tab name for the Store Setup Page for managing Checkout Rates',
    defaultMessage: 'Checkout Rates',
    id: 'upOTC4',
  },
  brandingTab: {
    description: 'Tab name for the Store Setup Page for managing Checkout Branding',
    defaultMessage: 'Branding',
    id: 'J1c38B',
  },
  trackingPageTab: {
    description: 'Tab name for the Store Setup Page for managing Tracking',
    defaultMessage: 'Tracking Page',
    id: '97zM9d',
  },
  returnsTab: {
    description: 'Tab name for the Store Setup Page for managing Returns',
    defaultMessage: 'Returns',
    id: 'tirUpZ',
  },
  returnsPortalTab: {
    description: 'Tab name for the Store Setup Page for managing Returns Portal when ShipStation Returns is enabled',
    defaultMessage: 'Returns Portal',
    id: 'ltErXx',
  },
  emailsTab: {
    description: 'Tab name for the Store Setup Page for managing Emails',
    defaultMessage: 'Emails',
    id: 'QUDffB',
  },
  notificationsTab: {
    description: 'Tab name for the Store Setup Page for managing Emails when the new Branded Tracking email experience is enabled',
    defaultMessage: 'Notifications',
    id: 'RxiMAU',
  },
  packingSlipsTab: {
    description: 'settings.stores.selectedStore.packingSlipsTab',
    defaultMessage: 'Packing Slips',
    id: 'UxVFh8',
  },
  productsTab: {
    description: 'Tab name for the Store Setup Page for managing Products',
    defaultMessage: 'Products',
    id: '+FgM4E',
  },
  shippingServicesTab: {
    description: 'Tab name for the Store Setup Page for managing Shipping Services',
    defaultMessage: 'Shipping Services',
    id: 'PEpK8I',
  },
  activityTab: {
    description: 'Tab name for the Store Setup Page for managing Activity',
    defaultMessage: 'Activity',
    id: '+/4MHl',
  },
  generalTabTitle: {
    defaultMessage: 'General Store Settings',
    id: 'vOmVs6',
    description: 'Title at the top of the page to describe to the user which settings page they are in.',
  },
  storeName: {
    description: 'Label for the Store Name text box',
    defaultMessage: 'Store Name',
    id: 'LaEq1d',
  },
  status: {
    description: 'Label for setting the store to active/inactive',
    defaultMessage: 'Status',
    id: 'wOJpoW',
  },
  activeLabel: {
    description: 'Label for the Active radio button',
    defaultMessage: 'Active',
    id: '3hKx17',
  },
  inactiveLabel: {
    description: 'Label for the inactive radio button',
    defaultMessage: 'Inactive',
    id: 'Rr1vMI',
  },
  storeStatusNote: {
    description: 'Note for the subtext displayed below Store Status Options',
    defaultMessage: 'Inactive stores are hidden by default.',
    id: 'M4rnLt',
  },
  importFrequency: {
    description: 'Label for setting the Import Frequency when Orders are imported into ShipStation',
    defaultMessage: 'Import Frequency',
    id: 'X65x50',
  },
  manualImport: {
    description: 'Label for the Manual Import option',
    defaultMessage: 'Manual Import',
    id: '2oOpla',
  },
  manualImportNote: {
    description: 'Note for the subtext displayed below the Manual Import Radio Button',
    defaultMessage: 'Imports order only when the refresh button is used.',
    id: 'LPAT+q',
  },
  automaticImport: {
    description: 'Label for the Automatic Import option',
    defaultMessage: 'Automatic Import',
    id: '/vYHc/',
  },
  automaticImportNote: {
    description: 'Note for the subtext displayed below the Automatic Import Radio Button',
    defaultMessage: 'Imports orders periodically, based on demand, in the background.',
    id: '+IAGRP',
  },
  automaticImportNoteForIOS: {
    description: 'Note for the subtext displayed below the Automatic Import Radio Button if the store is Instant Order Sync Enabled',
    defaultMessage: 'Imports whenever Shopify indicates new orders exist.',
    id: 'bMA+2O',
  },
  backgroundImport: {
    description: 'Label for the Background Import option',
    defaultMessage: 'Accelerated Manual Import',
    id: 'HFdbx9',
  },
  backgroundImportNote: {
    description: 'Note for the subtext displayed below the Background Import Radio Button',
    defaultMessage:
      "Imports order only when the refresh button is used. Using webhooks to pull directly from ShipStation's database. Imports orders faster for high volume or high data stores.",
    id: 'EHlgFr',
  },
  autoBackgroundImport: {
    description: 'Label for the Accelerated Automatic Import option',
    defaultMessage: 'Accelerated Automatic Import',
    id: 'sLAwP7',
  },
  autoBackgroundImportNote: {
    description: 'Note for the subtext displayed below the Accelerated Automatic Import Radio Button',
    defaultMessage:
      "Imports orders periodically, in the background. Using webhooks to pull directly from ShipStation's database. Imports orders faster for high volume or high data stores.",
    id: 'BbxSPN',
  },
  insightImportFrequencyTitle: {
    description: 'The title of the insights container to the right of the Import Frequency Options',
    defaultMessage: 'Check for new orders... whenever',
    id: 'WrdDs0',
  },
  insightImportFrequencyContent: {
    description: 'The content of the insights container to the right of the Import Frequency Options',
    defaultMessage:
      'Anytime you feel like checking for new orders, use the import {icon} action in the toolbar to update all stores, or see when each store was last updated.',
    id: '4S0w0c',
  },
  showMarketplaceSettingsHeader: {
    description: 'Text displayed below the Save button on the General Tab if the store has marketplace specific settings',
    defaultMessage: '{marketplaceName} Connection Settings',
    id: '+KFsGt',
  },
  showMarketplaceSettingsButtonText: {
    description: 'Label displayed on the button that when clicked, will display the marketplace specific settings for the store',
    defaultMessage: 'Edit {marketplaceName} Settings',
    id: 'XILxEg',
  },
  autoCorrectAddressesUS: {
    description: 'settings.stores.selectedStore.autoCorrectAddressesUS',
    defaultMessage: 'Automatically standardize and correct all US addresses when verified?',
    id: 'lOPbII',
  },
  standardizeAddress: {
    description: 'settings.stores.selectedStore.standardizeAddress.label',
    defaultMessage: 'Standardize Addresses When Verified',
    id: '+Y3B4B',
  },
  standardizeUSAddressLabel: {
    description: 'settings.stores.selectedStore.standardizeAddress.label.us',
    defaultMessage: 'Standardize and correct US addresses',
    id: '7PPy4T',
  },
  standardizeIntlAddressLabel: {
    description: 'settings.stores.selectedStore.standardizeAddress.label.intl',
    defaultMessage: 'Standardize and correct supported non-US addresses',
    id: 'jpVrpI',
  },
  autoCorrectAddressesIntl: {
    description: 'settings.stores.selectedStore.autoCorrectAddressesIntl',
    defaultMessage: 'Automatically standardize and correct supported non-US addresses when verified?',
    id: 'agHW9J',
  },
  autoCorrectAddressesIntlMessage: {
    description: 'settings.stores.selectedStore.autoCorrectAddressesIntlMessage',
    defaultMessage: 'International address verification support: CA, GB, AU, DE, FR, NO, ES, SE, IL and IT',
    id: '/R5fLO',
  },
  residentialCommercialIndicator: {
    description: 'Label for the setting that controls the default residential/commercial address designation',
    defaultMessage: 'Residential/Commercial Indicator Default',
    id: 'MtvkLU',
  },
  residentialCommercialIndicatorDescription: {
    description: 'Explanatory text for the residential/commercial indicator setting that tells users when this default will be applied',
    defaultMessage: 'Choose the default value when address validation returns an unknown residential/commercial status.',
    id: '5kQCIf',
  },
  defaultToCommercial: {
    description: 'Radio button option to set commercial as the default address type when no value is returned from validation',
    defaultMessage: 'Default to commercial if no value is returned',
    id: 'Pe6rO1',
  },
  defaultToResidential: {
    description: 'Radio button option to set residential as the default address type when no value is returned from validation',
    defaultMessage: 'Default to residential if no value is returned',
    id: 'NM/yyx',
  },
  defaultToMarketplace: {
    description: 'Radio button option to use the marketplace-provided residential/commercial designation when available',
    defaultMessage: 'Default to marketplace values if provided',
    id: 'Opt6ew',
  },
  marketplaceFallbackToCommercial: {
    description:
      'Radio button option to use commercial as the fallback when marketplace does not provide a residential/commercial designation',
    defaultMessage: 'Default to commercial if marketplace value is not provided',
    id: 'OFQ9Yy',
  },
  marketplaceFallbackToResidential: {
    description:
      'Radio button option to use residential as the fallback when marketplace does not provide a residential/commercial designation',
    defaultMessage: 'Default to residential if marketplace value is not provided',
    id: 'avsbMQ',
  },
  notificationHeader: {
    description: 'settings.stores.selectedStore.notificationHeader',
    defaultMessage:
      'ShipStation can send shipment and delivery confirmation emails to your customers using your specified template. <a>Create as many custom templates as you need.</a>',
    id: '/yQykE',
  },
  notificationHeaderNew: {
    description: 'settings.stores.selectedStore.notificationHeaderNew',
    defaultMessage:
      'ShipStation can automatically update your customers about their shipment status as updates are received from the carrier. Configure your email and marketplace notifications below.',
    id: 'sfW4/X',
  },
  bccDescription: {
    description: 'settings.stores.selectedStore.bccDescription',
    defaultMessage: 'BCC these email address(es) for enabled emails (comma-separated list)',
    id: 'pUZlDa',
  },
  bccConfirmationsLabel: {
    description: 'settings.stores.selectedStore.bccConfirmationLabel',
    defaultMessage: 'Also send to these email address(es)',
    id: 'uNwh5R',
  },
  bccEmailAddressLabel: {
    description: 'settings.stores.selectedStore.bccEmailAddressLabel',
    defaultMessage: 'BCC Email Address',
    id: 'rXwrqO',
  },
  shipmentEmailLabel: {
    description: 'settings.stores.selectedStore.shipmentEmailLabel',
    defaultMessage: 'Shipment Confirmation Email',
    id: 'KS8zSr',
  },
  shipmentEmailLabelNew: {
    description: 'settings.stores.selectedStore.shipmentEmailLabelNew',
    defaultMessage: 'Send Shipment Confirmation Email and Marketplace Notification',
    id: 'tuWmBY',
  },
  deliveryEmailLabel: {
    description: 'settings.stores.selectedStore.deliveryEmailLabel',
    defaultMessage: 'Delivery Notification Email',
    id: 'pnaFYA',
  },
  estDeliveryEmailLabel: {
    description: 'settings.stores.selectedStore.estDeliveryEmailLabel',
    defaultMessage: 'Send Estimated Delivery Date Email',
    id: 'hULUTo',
  },
  outForDeliveryEmailLabel: {
    description: 'settings.stores.selectedStore.outForDeliveryEmailLabel',
    defaultMessage: 'Out For Delivery Email',
    id: 'LmHkc9',
  },
  emailNotificationHeader: {
    description: 'settings.stores.selectedStore.emailNotificationHeader',
    defaultMessage: 'Email Notifications & Templates',
    id: 'CBJAoq',
  },
  additionalSettingsHeader: {
    description: 'settings.stores.selectedStore.additionalSettingsHeader',
    defaultMessage: 'Additional Settings',
    id: 'AkhouN',
  },
  shipmentEmailExplanation: {
    description: 'settings.stores.selectedStore.shipmentEmailExplanation',
    defaultMessage: 'Notifies buyers that their shipment is being prepared and label was created.',
    id: 'lhij+Y',
  },
  shipmentEmailExplanationNew: {
    description: 'settings.stores.selectedStore.shipmentEmailExplanationNew',
    defaultMessage: 'Notifies customers when their shipment is prepared and a label is created.',
    id: 'sTd9bt',
  },
  shipmentEmailLtlFreightNote: {
    description:
      'Note shown under the shipment confirmation email explanation when LTL Freight is enabled, clarifying that the setting does not apply to freight shipments',
    defaultMessage:
      '<bold>Note:</bold> This setting does not apply to freight shipments. ShipStation automatically notifies your marketplace on the first carrier-initiated scan and when a PRO number is assigned, regardless of this setting.',
    id: 'Hk5tPj',
  },
  estDeliveryEmailExplanation: {
    description: 'settings.stores.selectedStore.estDeliveryEmailExplanation',
    defaultMessage: 'Notifies customers when the shipment has hit the mailstream and has an estimated delivery date.',
    id: 'WRXedy',
  },
  outForDeliveryEmailExplanation: {
    description: 'settings.stores.selectedStore.outForDeliveryEmailExplanation',
    defaultMessage: 'Notifies customers that their shipment is out for delivery.',
    id: 'Lu0byV',
  },
  dontEmail: {
    description: 'settings.stores.selectedStore.dontEmail',
    defaultMessage: "(don't send email)",
    id: '+i5KuO',
  },
  notificationsFooter: {
    description: 'settings.stores.selectedStore.notificationFooter',
    defaultMessage: 'Emails will be sent based on tracking updates provided by the carriers.',
    id: 'hOpnwG',
  },
  deliveryEmailExplanation: {
    description: 'settings.stores.selectedStore.deliveryEmailExplanation',
    defaultMessage:
      "Select an email template that confirms the carrier's 'Delivered' status, thanks your customer for their purchase, and/or asks them to leave a review. Not to be used for marketing purposes. ShipStation reserves the right to disable this feature if your spam rating gets too high, or for any other reason.",
    id: 'kVrdWa',
  },
  deliveryEmailExplanationBranded: {
    description: 'settings.stores.selectedStore.deliveryEmailExplanationBranded',
    defaultMessage: 'Notifies customers that their shipment has arrived at its final destination.',
    id: 'U5G7/z',
  },
  amazonNotificationNote: {
    description: 'settings.stores.selectedStore.amazonNotificationNote',
    defaultMessage:
      'Note that ShipStation will not send shipment notification emails to email addresses ending in "marketplace.amazon.com." The email template selection option below only applies to <amazonEmailLink> Amazon Payments </amazonEmailLink> orders.',
    id: 'OwpH3S',
  },
  ebayNotificationNote: {
    description: 'settings.stores.selectedStore.ebayNotificationNote',
    defaultMessage:
      'Ensure your notification emails comply with <ebayLink>eBay’s member-to-member contact policy,</ebayLink> which prohibits exchanging personal contact information (except names). <span>For help creating a compliant email template, review our <helpLink>How do I create eBay Compliant email templates?</helpLink> article.</span>',
    id: '01I0yN',
  },
  tikTokNotificationNote: {
    description: 'Warning message displayed for TikTok marketplace in "Store settings" in section "Emails"',
    defaultMessage:
      'Note that ShipStation will not send shipment notification emails to email addresses ending in "@chat-seller-us.tiktok.com".',
    id: 'kcjxIt',
  },
  tikTokUKNotificationNote: {
    description: 'Warning message displayed for TikTokUK marketplace in "Store settings" in section "Emails"',
    defaultMessage:
      'Note that ShipStation will not send shipment notification emails to email addresses ending in "@chat-seller-us.tiktok.co.uk".',
    id: 'pn3xZK',
  },
  sheinNotificationNote: {
    description: 'Warning message displayed for Shein marketplace in "Store settings" in section "Emails"',
    defaultMessage: 'Note that ShipStation will not send shipment notifications to customer from this store.',
    id: 'V3qzD0',
  },
  packingSlipTemplateLabel: {
    description: 'settings.stores.selectedStore.packingSlipTemplateLabel',
    defaultMessage: 'Packing Slip Template',
    id: 'Cp/shr',
  },
  packingSlipFooterLabel: {
    description: 'settings.stores.selectedStore.packingSlipFooterLabel',
    defaultMessage: 'Packing Slip Footer',
    id: 'BnYuX8',
  },
  packingSlipFooterDescription: {
    description: 'settings.stores.selectedStore.packingSlipFooterDescription',
    defaultMessage: 'This message prints at the bottom of each packing slip.',
    id: '+oPgbV',
  },
  packingSlipDefault: {
    description: 'settings.stores.selectedStore.packingSlipFooterDescription',
    defaultMessage: 'Select a packing slip',
    id: '8WfpVi',
  },
  automaticCustomerFeedback: {
    description: 'settings.stores.selectedStore.automaticCustomerFeedback',
    defaultMessage: 'Automatic Customer Feedback',
    id: '0vg7X+',
  },
  automaticFeedbackDescription: {
    description: 'settings.stores.selectedStore.automaticFeedbackDescription',
    defaultMessage:
      "ShipStation can automatically leave feedback for completed transactions in your eBay marketplace. If you'd like to use this feature, specify up to 3 messages to be left for customers.",
    id: 'yEYcdR',
  },
  autoFeedbackMessage1: {
    description: 'settings.stores.selectedStore.autoFeedbackMessage1',
    defaultMessage: 'Message #1',
    id: 'qjSK6g',
  },
  autoFeedbackMessage2: {
    description: 'settings.stores.selectedStore.autoFeedbackMessage2',
    defaultMessage: 'Message #2',
    id: 'vrE+lU',
  },
  autoFeedbackMessage3: {
    description: 'settings.stores.selectedStore.autoFeedbackMessage3',
    defaultMessage: 'Message #3',
    id: 'ACEpFN',
  },
  trackingPageDescription: {
    description: 'settings.stores.selectedStore.trackingPageDescription',
    defaultMessage:
      'To send Branded Tracking Page links in your Shipment Confirmation emails, select "Branded Tracking Page" below. Otherwise, links sent in Shipment Confirmation emails will link to the Carrier\'s tracking page.',
    id: 'PK0E4m',
  },
  trackingPageDescriptionNew: {
    description: 'settings.stores.selectedStore.trackingPageDescriptionNew',
    defaultMessage:
      'Select whether you want the tracking link in your shipment confirmation emails to direct to the carrier’s tracking page or to a “branded” tracking page, which you can customize with your store branding settings.',
    id: 'hJGZzk',
  },
  carrierTrackingPage: {
    description: 'settings.stores.selectedStore.carrierTrackingPage',
    defaultMessage: 'Use Carrier Tracking Page',
    id: 'nmfKXI',
  },
  localDeliveryTrackingDisclaimer: {
    description: 'local delivery tracking link disclaimer',
    defaultMessage: 'Local Delivery shipments will default to carrier tracking link for better tracking visibility.',
    id: 'bk9yUx',
  },
  brandedTrackingPage: {
    description: 'settings.stores.selectedStore.brandedTrackingPage',
    defaultMessage: 'Use Branded Tracking Page',
    id: 'bg21Tf',
  },
  productTabDescription: {
    description: 'settings.stores.selectedStore.productTabDescription',
    defaultMessage:
      'ShipStation can save products that are ordered from this store. This allows you to set Product Details and view reports on your products. The following settings tell ShipStation how to handle products for this store.',
    id: 's2uw0e',
  },
  createNewProductLabel: {
    description: 'settings.stores.selectedStore.createNewProductLabel',
    defaultMessage: 'As ShipStation identifies new products that are ordered from this store',
    id: 'YVMlbw',
  },
  createNewProductRecordLabel: {
    description: 'settings.stores.selectedStore.createNewProductRecordLabel',
    defaultMessage: 'Create a new product record so that details can be configured.',
    id: 'kn0asr',
  },
  doNotCreateProductRecord: {
    description: 'settings.stores.selectedStore.doNotCreateProductRecord',
    defaultMessage: 'Do NOT create a product record',
    id: 'K4IlGI',
  },
  productIdentificationLabel: {
    description: 'settings.stores.selectedStore.productIdentificationLabel',
    defaultMessage: 'Products for this store are uniquely identified by this',
    id: 'Ju05+G',
  },
  productSku: {
    description: 'settings.stores.selectedStore.productSku',
    defaultMessage: 'Product <strong>SKU</strong>',
    id: 'O+fTUm',
  },
  productName: {
    description: 'settings.stores.selectedStore.productName',
    defaultMessage: 'Product / Listing <strong>Name</strong>',
    id: 'OX6wT9',
  },
  couponsDiscountsLabel: {
    description: 'settings.stores.selectedStore.couponsDiscountsLabel',
    defaultMessage: 'Coupons, Discounts, or other Adjustments',
    id: 'ygi+pE',
  },
  couponsNotIncluded: {
    description: 'settings.stores.selectedStore.couponsNotIncluded',
    defaultMessage:
      '<strong>Not Included</strong> on product sales reports.  No product record will be created for adjustment lines items.',
    id: 'Qs8YBC',
  },
  couponsIncluded: {
    description: 'settings.stores.selectedStore.couponsIncluded',
    defaultMessage: '<strong>Included.</strong> Product records will be created for adjustment line items and appear on reports.',
    id: '0/HgXh',
  },
  shippingServiceDescription: {
    description: 'settings.stores.selectedStore.shippingServiceDescription',
    defaultMessage:
      "Tell us how you'd like to handle your service classes in ShipStation. We'll automatically apply these settings for you.",
    id: 'G6KeLI',
  },
  addServiceMapping: {
    description: 'settings.stores.selectedStore.addServiceMapping',
    defaultMessage: 'Add Service Mapping',
    id: 'HG6dnC',
  },
  requestedService: {
    description: 'settings.stores.selectedStore.',
    defaultMessage: 'Requested Service',
    id: 'sE7Skq',
  },
  shippingService: {
    description: 'settings.stores.selectedStore.shippingService',
    defaultMessage: 'Shipping Service',
    id: 'PBaNDI',
  },
  fulfillment: {
    description: 'settings.stores.selectedStore.fulfillment',
    defaultMessage: 'Fulfillment',
    id: 'rZUSsN',
  },
  actions: {
    description: 'settings.stores.selectedStore.actions',
    defaultMessage: 'Actions',
    id: 'dz4ndY',
  },
  edit: {
    description: 'settings.stores.selectedStore.edit',
    defaultMessage: 'Edit',
    id: 'SeGZNA',
  },
  delete: {
    description: 'settings.stores.selectedStore.delete',
    defaultMessage: 'Delete',
    id: 'bdtvDM',
  },
  editServiceMapping: {
    description: 'settings.stores.selectedStore.editServiceMapping',
    defaultMessage: 'Edit your Service Mapping',
    id: 'EWRbFi',
  },
  editServiceMappingDescription: {
    description: 'settings.stores.selectedStore.editServiceMappingDescription',
    defaultMessage:
      "We don't want to assume anything, so if you tell us how you'd like to handle <green>this service</green> in the future, we'll automatically apply these settings for you.",
    id: 'R45LzU',
  },
  cancel: {
    description: 'settings.stores.selectedStore.cancel',
    defaultMessage: 'Cancel',
    id: 'yXfst0',
  },
  save: {
    description: 'settings.stores.selectedStore.save',
    defaultMessage: 'Save',
    id: 'aOfQps',
  },
  serviceKey: {
    description: 'settings.stores.selectedStore.serviceKey',
    defaultMessage: 'Service Key',
    id: 'ZUFFF0',
  },
  service: {
    description: 'settings.stores.selectedStore.service',
    defaultMessage: 'Service',
    id: 'IsjNqA',
  },
  package: {
    description: 'settings.stores.selectedStore.package',
    defaultMessage: 'Package',
    id: 'dmJcGO',
  },
  fillMethod: {
    description: 'settings.stores.selectedStore.fillMethod',
    defaultMessage: 'Fill Method',
    id: '2UQWrv',
  },
  shipping: {
    description: 'settings.stores.selectedStore.shipping',
    defaultMessage: 'Shipping',
    id: 'O1JJ3N',
  },
  shipFrom: {
    description: 'settings.stores.selectedStore.shipFrom',
    defaultMessage: 'Ship From',
    id: 'Exu8aO',
  },
  activityMetadata: {
    description: 'settings.stores.selectedStore.by',
    defaultMessage: '{date} {time} by',
    id: 'cpwVld',
  },
  storeActivity: {
    description: 'settings.stores.selectedStore.storeActivity',
    defaultMessage: 'Store Activity',
    id: 'O6wYTJ',
  },
  loadMore: {
    description: 'settings.stores.selectedStore.loadMore',
    defaultMessage: 'Load more',
    id: 'Yf3zFR',
  },
  selectAService: {
    description: 'returnSettings.selectAService',
    defaultMessage: 'You must select a service and a package (above) to generate your URL.',
    id: 'esbui1',
  },
  fixAllErrors: {
    description: 'returnSettings.fixAllErrors',
    defaultMessage: 'You must fix all errors to generate your URL.',
    id: 'WZ4X7L',
  },
  url: {
    description: 'returnsSettings.url',
    defaultMessage: 'URL',
    id: '6lspIU',
  },
  brandingPageTitle: {
    defaultMessage: 'General Branding Settings',
    description: 'Title for the general branding settings section',
    id: 'P4Yb2j',
  },
  brandingInstructionsLine1: {
    defaultMessage:
      'Add your store’s branding details to use on packing slips, shipment notification emails, and your branded tracking and returns pages.',
    description: 'Information about the general branding settings section',
    id: 'JkoXUV',
  },
  brandingInstructionsLine2: {
    defaultMessage:
      'By default, notification emails to your customers are sent from tracking@shipstation.com. To configure ShipStation to send emails from your own email address, add the email to these settings and then verify it and authenticate your domain in the <a>Sender Emails</a> settings.',
    description: 'Information about notification emails',
    id: 'RKULEJ',
  },
  brandingInstructionsBanner: {
    defaultMessage:
      'While you can add emails with public domains (like gmail.com, yahoo.com, etc) and verify them for use in templates, these email addresses cannot be used as a sender email.',
    description: 'Information about using public domain email addresses for branding',
    id: '1SbJbj',
  },
  emailChangedModalHeader: {
    defaultMessage: 'Email Address Changed',
    description: 'Header for the email changed modal',
    id: 'zOUU5w',
  },
  emailChangedModalText: {
    defaultMessage: 'You must verify your new email address and authenticate the domain. Go to <a>Settings > Sender Emails</a>.',
    description: 'Message telling the user to verify their email',
    id: 'Tcsjmi',
  },
  companyName: {
    description: 'settings.stores.selectedStore.companyName',
    defaultMessage: 'Company Name',
    id: 'YLegH5',
  },
  alwaysUseCompanyName: {
    description: 'settings.stores.selectedStore.alwaysUseCompanyName',
    defaultMessage: 'Always use Company Name on the Return Address printed on outbound labels.',
    id: 'yNNV9m',
  },
  phone: {
    description: 'settings.stores.selectedStore.phone',
    defaultMessage: 'Phone',
    id: 'a4ZCNF',
  },
  phoneInfo: {
    defaultMessage: 'Allowed characters: alphanumeric ( ) . : and -',
    id: 'eOIaNH',
    description: 'allowable characters in the phone input',
  },
  email: {
    description: 'settings.stores.selectedStore.email',
    defaultMessage: 'Email',
    id: 'rdOABJ',
  },
  storeLogo: {
    description: 'settings.stores.selectedStore.storeLogo',
    defaultMessage: 'Store Logo',
    id: '9gm3QA',
  },
  selectFile: {
    description: 'Branding tab click to upload a file',
    defaultMessage: 'Upload a Logo File',
    id: 'wgAk7M',
  },
  helperSentence: {
    description: 'Helper sentence under upload a logo file',
    defaultMessage:
      'We recommend a PNG, SVG, or JPEG file no larger than 500-900 kb, and a square or wide proportion for the best display.',
    id: 'yuccWL',
  },
  remove: {
    description: 'Remove a store logo',
    defaultMessage: 'Remove',
    id: 'joaMEY',
  },
  website: {
    description: 'settings.stores.selectedStore.website',
    defaultMessage: 'Website',
    id: 'KWPLY6',
  },
  socialLinks: {
    description: 'settings.stores.selectedStore.socialLinks',
    defaultMessage: 'Social Links',
    id: '+RHJIE',
  },
  facebookProfile: {
    description: 'settings.stores.selectedStore.facebookProfile',
    defaultMessage: 'Facebook Profile',
    id: 'a21maq',
  },
  instagramProfile: {
    description: 'settings.stores.selectedStore.instagramProfile',
    defaultMessage: 'Instagram Profile',
    id: 'UBy6OQ',
  },
  twitterProfile: {
    description: 'settings.stores.selectedStore.twitterProfile',
    defaultMessage: 'Twitter Profile',
    id: 'k8Gmru',
  },
  showWebsite: {
    description: 'settings.stores.selectedStore.showWebsite',
    defaultMessage: 'Website',
    id: 'gYwl1C',
  },
  configuredForEachStore: {
    description: 'settings.stores.selectedStore.configuredForEachStore',
    defaultMessage: 'Configured for each store',
    id: 'GpWell',
  },
  additionalLinks: {
    description: 'settings.stores.selectedStore.additionalLinks',
    defaultMessage: 'Additional Links',
    id: 'HhiY/v',
  },
  additionalLinksDesc: {
    description: 'settings.stores.selectedStore.additionalLinksDesc',
    defaultMessage: 'Provide additional links to your sale items, reviews pages, etc...',
    id: 'c3vxga',
  },
  text: {
    description: 'settings.stores.selectedStore.text',
    defaultMessage: 'Text:',
    id: 'Nmf5ob',
  },
  linkUrl: {
    description: 'settings.stores.selectedStore.linkUrl',
    defaultMessage: 'Url:',
    id: 'W+hfwr',
  },
  returnPolicy: {
    description: 'settings.stores.selectedStore.returnPolicy',
    defaultMessage: 'Return Policy',
    id: '9z52f9',
  },
  emailSettings: {
    description: 'Return Email settings checkbox label',
    defaultMessage: 'Return Email Message',
    id: 'tbwFsC',
  },
  contactUs: {
    description: 'settings.stores.selectedStore.contactUs',
    defaultMessage: 'Contact Us',
    id: 'Ag1Zcs',
  },
  contactDesc: {
    description: 'settings.stores.selectedStore.contactDesc',
    defaultMessage: 'Display contact information under Service menu',
    id: 'Fc2faT',
  },
  contactEmail: {
    description: 'settings.stores.selectedStore.contactEmail',
    defaultMessage: 'Contact Email',
    id: 'qS+21z',
  },
  contactPhone: {
    description: 'settings.stores.selectedStore.contactPhone',
    defaultMessage: 'Contact Phone',
    id: 'NhjA1U',
  },
  select: {
    description: 'settings.stores.selectedStore.showPrices',
    defaultMessage: 'Select',
    id: 'Bv6e40',
  },
  fulfillmentSettings: {
    description: 'settings.stores.selectedStore.fulfillmentSettings',
    defaultMessage: 'Fulfillment Settings',
    id: 'kq8sjT',
  },
  shippingSettings: {
    description: 'settings.stores.selectedStore.shippingSettings',
    defaultMessage: 'Shipping Settings',
    id: 'sQ6UOe',
  },
  verifyEmailLink: {
    description: 'branding tab verify email link',
    defaultMessage: '<buttonLink>Verify this email address</buttonLink> before sending shipment notifications.',
    id: '+1nnCI',
  },
  resendVerificationLink: {
    description: 'branding tab resend verification link',
    defaultMessage: 'This email is pending. <buttonLink>Re-send verification?</buttonLink>',
    id: '8NtulV',
  },
  alreadyVerified: {
    description: 'branding tab email already verified',
    defaultMessage: 'This email address has been verified for your account.',
    id: '2UW7rr',
  },
  checkingStatus: {
    description: 'branding tab checking email verification status',
    defaultMessage: 'Checking email verification status...',
    id: 'Dc5uGg',
  },
  smsNotifications: {
    description: 'settings.stores.selectedStore.smsNotifications',
    defaultMessage: 'SMS Notifications',
    id: 'hmqNNi',
  },
  smsNotificationDescription: {
    description: 'settings.stores.selectedStore.smsNotificationDescription',
    defaultMessage:
      'To allow your customers the ability to receive shipment notifications by text message, choose whether to show or hide the SMS opt-in field on the Branded Tracking Page. See our articles about <sms>SMS Notifications</sms> and <msglimits>message limitations</msglimits> to learn more.',
    id: 'CUjIyj',
  },
  enableSMS: {
    description: 'settings.stores.selectedStore.enableSMS',
    defaultMessage: 'Enable Branded SMS Shipment Notifications (show this on my Branded Tracking Page)',
    id: '8PGx8T',
  },
  disableSMS: {
    description: 'settings.stores.selectedStore.disableSMS',
    defaultMessage: 'Disable Branded SMS Shipment Notifications (keep it hidden from customers)',
    id: 'fv0D+j',
  },
  notificationErrorTitle: {
    description: 'notification growler error title',
    defaultMessage: 'Store Setting Error',
    id: 'ikoSRn',
  },
  notificationErrorContent: {
    description: 'notification growler error content',
    defaultMessage: 'There was an error saving your store setting. Please try again.',
    id: 'IHIqxx',
  },
  checkoutRateNotificationTitle: {
    description: 'notification growler title for new checkout rate',
    defaultMessage: 'Checkout Rate Saved Successfully',
    id: 'hTY+zO',
  },
  editCheckoutRateActiveNotificationContent: {
    description: 'notification growler for edited active checkout rate',
    defaultMessage: 'You updated a Checkout Rate! It is currently active and visible to your customers.',
    id: 'zz3YKw',
  },
  editCheckoutRateNotActiveNotificationContent: {
    description: 'notification growler for edited inactive checkout rate',
    defaultMessage: "You updated a Checkout Rate! It's not yet visible to customers. To show in cart, change the status to active.",
    id: 'OF1fTn',
  },
  checkoutRateInactiveNotificationContent: {
    description: 'notification growler content for new inactive checkout rate',
    defaultMessage: "You saved a new Checkout Rate but it's not yet visible to customers. To show in cart, change the status to active.",
    id: 'VK73Jo',
  },
  fulfillmentRateNotificationTitle: {
    description: 'notification growler title for new fulfillment rate',
    defaultMessage: 'Fulfillment Rate Saved Successfully',
    id: 'VBru3K',
  },
  fulfillmentRateActiveNotificationContent: {
    description: 'notification growler for new inactive fulfillment rate',
    defaultMessage: 'You added a new Fulfillment Rate! It is currently active and visible to your merchants.',
    id: 'e4eosD',
  },
  fulfillmentRateInactiveNotificationContent: {
    description: 'notification growler content for new active fulfillment rate',
    defaultMessage: "You saved a new Fulfillment Rate but it's not yet visible to merchants. To show, change the status to active.",
    id: 'DBU5mY',
  },
  fieldRequiredError: {
    description: 'store settings required field error info',
    defaultMessage: 'This field is required.',
    id: 'bNvFbg',
  },
  country: {
    description: 'delivery options preview country dropdown',
    defaultMessage: 'Country',
    id: 'g+fHLI',
  },
  zipCode: {
    description: 'delivery options preview postal code input',
    defaultMessage: 'Postal Code',
    id: 'izSuZa',
  },
  packageWeight: {
    description: 'delivery options preview package weight',
    defaultMessage: 'Weight',
    id: '6Cwrhh',
  },
  packageDimensions: {
    description: 'delivery options preview package Package Dimensions',
    defaultMessage: 'Package Dimensions',
    id: '4FSuoy',
  },
  previewDeliveryOption: {
    description: 'delivery options preview',
    defaultMessage: 'Preview',
    id: 'Oj0X/A',
  },
  previewRates: {
    description: 'checkout rates preview displays',
    defaultMessage: 'Preview Rates',
    id: 'OYy01Y',
  },
  previewDescription: {
    description: 'delivery options example description',
    defaultMessage:
      'Your {marketplaceName} marketplace will sort by price, from lowest to highest. Prices and shipping times are examples only. Colors, fonts, and user interface elements may be different in the checkout.',
    id: 'kUlemC',
  },
  deliveryEstimate: {
    description: 'delivery options preview delivery estimate',
    defaultMessage: '{numberOfDays, plural, one {# day} other {# days}}',
    id: 'LEDOol',
  },
  deliveryEstimateRange: {
    description: 'delivery options preview delivery estimate range',
    defaultMessage: '{minNumberOfDays} to {maxNumberOfDays} days',
    id: 'bx52PB',
  },
  notificationTiming: {
    description: 'input label for settings related to when notifications should be sent',
    defaultMessage: 'Send email and marketplace notification when...',
    id: 'erMFx9',
  },
  notificationTimingNew: {
    description: 'input label for settings related to when notifications should be sent, new email experience',
    defaultMessage: 'Send email and marketplace notification when:',
    id: 'Zvis90',
  },
  shippingLabelOption: {
    description: 'radio option to send notification when the shipping label is created',
    defaultMessage: 'Shipping label is created',
    id: 'bQ5OVl',
  },
  localDeliveryDisclaimer: {
    description: 'local delivery shipment email disclaimer about mail stream events',
    defaultMessage:
      'Local Delivery shipments will not detect mail stream events for notifications. We recommend leaving the Shipment Confirmation Email option set to "Shipping label is created"',
    id: 'lpydVX',
  },
  firstOfConditions: {
    description: 'radio option to use one of various available criteria',
    defaultMessage: 'The first of these conditions is met:',
    id: 'lTV8d1',
  },
  hitsMailStream: {
    description: 'checkbox for the sending when the shipment hits the mail stream',
    defaultMessage: 'This shipment first hits the mail stream',
    id: 'jxKNoU',
  },
  hitsMailStreamNew: {
    description: 'checkbox for the sending when the shipment hits the mail stream, new email experience',
    defaultMessage: 'This shipment first hits the mail',
    id: '0zyVRy',
  },
  atSpecificTime: {
    description: 'checkbox for sending at a specific time',
    defaultMessage: 'At a specific time on the ship date',
    id: 'hy0JTu',
  },
  atSpecificTimeNew: {
    description: 'checkbox for sending at a specific time, new email experience',
    defaultMessage: 'At specific time of the ship date',
    id: 'HvuGSd',
  },
  atSpecificTimeAdditionalInfo: {
    description: 'extra label for info related to time zones',
    defaultMessage: '(Based on your account <a>time zone</a>)',
    id: 'MnIKov',
  },
  atSpecificTimeAdditionalInfoNew: {
    description: 'extra label for info related to time zones, new email experience',
    defaultMessage: 'Based on your account time zone',
    id: 'JWGRqW',
  },
  numberOfHours: {
    description: 'checkbox for number of hours after label creation',
    defaultMessage: 'Number of hour(s) elapsed after label creation',
    id: 'Id362y',
  },
  numberOfHoursAdditionalInfo: {
    description: 'extra label for additional hours input',
    defaultMessage: '(# of hours)',
    id: 'nvMtZq',
  },
  numberOfHoursUnitLabel: {
    description: 'unit label shown inside the hours input, new email experience',
    defaultMessage: 'hour(s)',
    id: 'mgFwvP',
  },
  trackableNumberOfHoursInputLabel: {
    description: 'accessible name for the trackable number-of-hours input, new email experience',
    defaultMessage: 'Number of hours elapsed after label creation for trackable carriers and services',
    id: 'BoDSty',
  },
  untrackableNumberOfHoursInputLabel: {
    description: 'accessible name for the untrackable number-of-hours input, new email experience',
    defaultMessage: 'Number of hours elapsed after label creation for untrackable carriers and services',
    id: 'dW6PRd',
  },
  untrackableOptionsLabel: {
    description: 'label for options untrackable carriers and services',
    defaultMessage: 'For un-trackable carriers and services, send notifications when:',
    id: 'r2s1nu',
  },
  untrackableOptionsLabelNew: {
    description: 'label for options untrackable carriers and services, new email experience',
    defaultMessage: 'For untrackable carriers and services, send notifications when:',
    id: 'z2kLX+',
  },
  shippingDetails: {
    description: 'delivery options preview form shipping details section title',
    defaultMessage: 'Shipping Details',
    id: '2ZBTAG',
  },
  checkoutRateDisplays: {
    description: 'checkout rates preview form checkout rate displays',
    defaultMessage: 'Checkout Rate Displays',
    id: 'AE4r0D',
  },
  advancedModeExplainer: {
    description: 'delivery options preview advanced mode explainer',
    defaultMessage:
      'For a more accurate preview, please enter the full address with the Advanced Preview Options. All fields are required.',
    id: '4fYpbd',
  },
  estimatedTransitTime: {
    description: 'delivery options preview estimated transit time',
    defaultMessage: 'Estimated Transit Time',
    id: 'kG/hhq',
  },
  activeStatus: {
    description: 'delivery options preview active status',
    defaultMessage: 'Active',
    id: 'aq9iA3',
  },
  inactiveStatus: {
    description: 'delivery options preview inactive status',
    defaultMessage: 'Inactive',
    id: 'UCs48m',
  },
  incompleteAddress: {
    description: 'delivery options preview incomplete address status',
    defaultMessage: 'Incomplete Address',
    id: 'Qs7XyQ',
  },
  noRate: {
    description: 'delivery options preview no rate status',
    defaultMessage: 'No Rate',
    id: 'Uj4Nkd',
  },
  similarOptions: {
    description: 'delivery options preview similar options status',
    defaultMessage: 'Similar Options',
    id: '6C/An/',
  },
  similarOptionsDescription: {
    description: 'delivery options preview similar options description',
    defaultMessage: 'This option would not be shown in the shopping cart since there are similar options at a lower price.',
    id: 'EmmyM5',
  },
  noRateDescription: {
    description: 'delivery options preview no rate description',
    defaultMessage: 'No rate returned from carrier(s).',
    id: 'C+YuiK',
  },
  inactiveDescriptionCR: {
    description: 'checkout rates preview inactive description',
    defaultMessage: 'To make this option visible in-cart, set this checkout rate to active.',
    id: '1iTPjg',
  },
  fullAddressRequiredDescription: {
    description: 'checkout rates preview full address required description',
    defaultMessage: 'Full address required to preview local delivery rate.',
    id: '4U3xfz',
  },
  numberOfDays: {
    description: 'delivery options preview similar options description',
    defaultMessage: '# of days',
    id: 'G3y9rw',
  },
  checkoutRateName: {
    description: 'checkout rates name column',
    defaultMessage: 'Name',
    id: '0MQ2Ij',
  },
  active: {
    description: 'delivery options active column',
    defaultMessage: 'Active',
    id: '+wEOAU',
  },
  services: {
    description: 'delivery options services column',
    defaultMessage: 'Services',
    id: '90FXtp',
  },
  pricing: {
    description: 'delivery options pricing column',
    defaultMessage: 'Pricing',
    id: 'OuXKqM',
  },
  actionColumn: {
    description: 'delivery options action column',
    defaultMessage: 'Action',
    id: '5w7lbG',
  },
  editDeliveryOption: {
    description: 'delivery options edit button',
    defaultMessage: 'Edit',
    id: 'M/f+sF',
  },
  copyDeliveryOption: {
    description: 'delivery options copy button',
    defaultMessage: 'Copy',
    id: 'HY0BwX',
  },
  deleteDeliveryOption: {
    description: 'delivery options delete button',
    defaultMessage: 'Delete',
    id: 'XPXqfZ',
  },
  accountSelectorDefault: {
    description: 'delivery options account selector default',
    defaultMessage: 'My Primary Account (Default)',
    id: 'k8JvIh',
  },
  myPrimaryAccount: {
    description: 'delivery options my prmary account default',
    defaultMessage: 'My Primary Account',
    id: 'upL1p/',
  },
  defineCheckoutRateTitle: {
    description: 'Create or Edit Checkout Rate Page Title',
    defaultMessage: 'Define Checkout Rate',
    id: 'MNQ04N',
  },
  servicesSctionTitle: {
    description: 'Title for services section',
    defaultMessage: 'Services',
    id: 'wjJZLC',
  },
  servicesSectionSubHeader: {
    description: 'Services section info line 1',
    defaultMessage: 'Select the type of shipment this rate is for and choose which services to compare',
    id: '7Xrxtq',
  },
  servicesSectionInfo: {
    description: 'Services section info line 2',
    defaultMessage: 'The rate shown at checkout will be the cheapest rate from your selected services.',
    id: '4p2hPJ',
  },
  defineCheckoutRateDescription: {
    description: 'Define Checkout Rate Page Title',
    defaultMessage:
      'Define the type of rate, adjust options, and give it a title and description the customer will see during checkout.{br}<a>Learn more about Checkout Rates</a>',
    id: '0UEHHJ',
  },
  shippingServiceDropdownPlaceholder: {
    description: 'Edit Delivery Option, Select Service Dropdown Placeholder',
    defaultMessage: 'Select one or more services...',
    id: 'wpybj2',
  },
  fulfillmentShippingServiceDropdownPlaceholder: {
    description: 'Edit Fulfillment Rate Option, Select Service Dropdown Placeholder',
    defaultMessage: 'Select a service...',
    id: 'hOcFlH',
  },
  checkoutRateInputTitle: {
    description: 'checkout rate title field',
    defaultMessage: 'Rate Name',
    id: 'W2M9Hk',
  },
  nameAndDescriptionSectionTitle: {
    description: 'Name and desctiption sction title',
    defaultMessage: 'Rate Name & Description',
    id: 'nTWkaW',
  },
  checkoutRateTitleSubHeader: {
    description: 'checkout rate title info',
    defaultMessage: 'Set the rate name and description your customers will see at checkout.',
    id: 'crv82c',
  },
  pudoCheckoutRateTitle: {
    description: 'checkout rate title field for pickup drop off',
    defaultMessage: 'Internal Title',
    id: 'SyQTs5',
  },
  fulfillmentRateTitle: {
    description: 'fulfillment rate title field for Flat Rate',
    defaultMessage: 'Service Name',
    id: '3MTpS4',
  },
  checkoutRateNamePlaceholder: {
    description: 'delivery options name placeholder message',
    defaultMessage: 'E.g., "Standard Delivery"',
    id: 'BwsQ6F',
  },
  checkoutRateLocalDeliveryNamePlaceholder: {
    description: 'delivery options name placeholder message for local delivery',
    defaultMessage: 'E.g., "Local Delivery"',
    id: '1G3UEo',
  },
  checkoutRateLocalDeliveryDescriptionPlaceholder: {
    description: 'delivery options name placeholder message',
    defaultMessage: 'E.g., "A driver delivers directly to you"',
    id: 'ygbg98',
  },
  checkoutRateDescriptionPlaceholder: {
    description: 'delivery options name placeholder message',
    defaultMessage: 'E.g., "7-10 Business days"',
    id: 'hNBFbC',
  },
  visibleToCustomers: {
    description: 'delivery options visible to customers message',
    defaultMessage: '(Visible to your customers at checkout)',
    id: 'MJSHTA',
  },
  enterName: {
    description: 'checkout rates enter name error',
    defaultMessage: 'Enter Name',
    id: 'DJtnTa',
  },
  enterDisplayName: {
    description: 'delivery options enter display name error',
    defaultMessage: 'Enter Display Name',
    id: 'WAA8+i',
  },
  deliveryOptionDescription: {
    description: 'delivery options description section',
    defaultMessage: 'Description',
    id: 'ASHH2B',
  },
  statusLabel: {
    description: 'checkout rates active section',
    defaultMessage: 'Status',
    id: 'wyYZfY',
  },
  rateType: {
    description: 'checkout rates rate type',
    defaultMessage: 'Rate Type',
    id: 'mTxXNh',
  },
  selectMethod: {
    description: 'checkout rates select method',
    defaultMessage: 'Select Method',
    id: 'Mo4oBv',
  },
  liveRate: {
    description: 'checkout rates live rate method',
    defaultMessage: 'Live Rate',
    id: '0s6N14',
  },
  localDeliveryRate: {
    description: 'checkout rates local delivery rate method',
    defaultMessage: 'Local Delivery Rate',
    id: 'YT65Wt',
  },
  freeMethod: {
    description: 'checkout rates free method',
    defaultMessage: 'Free',
    id: 'DnqQ00',
  },
  flatRate: {
    description: 'checkout rates flat rate method',
    defaultMessage: 'Flat Rate',
    id: 'VyvBcS',
  },
  liveRateDescription: {
    description: 'checkout rates live rate description',
    defaultMessage: 'Offer the best rate from a selection of services.',
    id: 'Qyl3NB',
  },
  localDeliveryRateDescription: {
    description: 'checkout rates local delivery rate description',
    defaultMessage: 'Set options for rates offered for Local Delivery.',
    id: 'OpxEhY',
  },
  freeMethodDescription: {
    description: 'checkout rates free rate description',
    defaultMessage: 'Offer a free shipping option to customers.',
    id: 'fYBdII',
  },
  flatRateTypeDescription: {
    description: 'checkout rates flat rate description',
    defaultMessage: 'Define a set price to charge for this shipment.',
    id: 'xTP3yy',
  },
  fulfillmentFlatRateTypeDescription: {
    description: 'fulfillment rates flat rate description',
    defaultMessage: 'A single fixed price for any destination or weight.',
    id: 'qLJJfE',
  },
  doNotDisplay: {
    description: 'delivery options fallback option do not display',
    defaultMessage: 'Do not display this rate',
    id: 'HOqRAK',
  },
  chargeFlatRate: {
    description: 'delivery options fallback option charge a flat rate',
    defaultMessage: 'Charge a flat rate',
    id: 'YnxlWU',
  },
  chargePercentageOfCart: {
    description: 'delivery options fallback option charge a percentage of cart',
    defaultMessage: 'Charge a % of Cart',
    id: 'u5nReU',
  },
  selectAnOption: {
    description: 'delivery options select pricing model error message',
    defaultMessage: 'Select an option.',
    id: 'cOZ7ve',
  },
  flatRateConfiguration: {
    description: 'delivery options flat rate configuration',
    defaultMessage: 'Flat Rate Configuration',
    id: '+hp9Hu',
  },
  flatRateDescription: {
    description: 'delivery options flat rate model desciption',
    defaultMessage: 'The price below will be the only price displayed no matter the shipping cost.',
    id: 'JQSqSe',
  },
  flatRatePrice: {
    description: 'delivery options flat rate price',
    defaultMessage: 'Flat Rate Price',
    id: 'BjgXPb',
  },
  flatRatePriceDescription: {
    description: 'delivery options flat rate model desciption',
    defaultMessage: 'Charge this fixed price to merchants for all orders.',
    id: 'YjXrte',
  },
  selectService: {
    description: 'checkout rates select service',
    defaultMessage: 'Service',
    id: '8XH6L/',
  },
  selectCarrierRate: {
    description: 'fulfillment rates select carrier rate',
    defaultMessage: 'Carrier Rate',
    id: 'fzVN2p',
  },
  localDeliveryAvailability: {
    description: 'checkout rates local delivery availability section title',
    defaultMessage: 'Local Delivery Availability',
    id: '2fV0Ba',
  },
  checkoutDisplayAvailabilityNotDefined: {
    description: 'checkout rates display availability not yet defined message',
    defaultMessage: "Available Hours need to be defined in your default Ship From Location's pickup settings.",
    id: 'fa3b8s',
  },
  addAvailabileHours: {
    description: 'checkout rates add availabile hours link',
    defaultMessage: 'Add Available Hours',
    id: 'YNkz9K',
  },
  closed: {
    description: 'pickup schedule for warehouse closed',
    defaultMessage: 'Closed',
    id: 'wc5HZ5',
  },
  pickupTimeZoneNote: {
    description: 'pickup schedule timezone note',
    defaultMessage: 'All times in the "{timezone}" time zone. Edit this schedule in your default Ship From Location <a>Pickup Settings</a>',
    id: '5ShxpI',
  },
  removeDuplicateServices: {
    description: 'delivery options remove duplicate service error message',
    defaultMessage: 'Remove duplicate services with same carrier accounts.',
    id: 'NIqaCn',
  },
  rateAdjustment: {
    description: 'checkout rates rate adjustment title',
    defaultMessage: 'Rate Adjustment',
    id: 'KJjsQ9',
  },
  rateAdjustmentsExplanation: {
    description: 'delivery options rate adjustments explanation',
    defaultMessage: 'Adjust the rate you offer your customer during checkout to be either more or less than the carrier’s actual rate.',
    id: '9Zs6Bn',
  },
  ratesAdjustmentTooltip: {
    description: 'Further information as to what the rate adjustment is used for',
    defaultMessage:
      'Adjusting rates to charge your customer more can help offset additional costs you might incur, like packing materials or shipment options required by your products (like Signature Confirmation).',
    id: 'dDmNo0',
  },
  rateAdjustmentsExplanationLocalDelivery: {
    description: 'delivery options rate adjustments explanation for local delivery',
    defaultMessage:
      'Need to build in the cost of packaging or cover your default local delivery tip? Customers wish this rate was a little less costly? Add or deduct from the rate to adjust what they will be charged.',
    id: '4xlvGg',
  },
  selectTypeOfAdjustment: {
    description: 'delivery options rate adjustments radio',
    defaultMessage: 'Adjustment',
    id: 'RSQo6w',
  },
  adjustmentNone: {
    description: 'delivery options rate adjustments type none',
    defaultMessage: 'None',
    id: 'k8V5wv',
  },
  adjustmentAddToRate: {
    description: 'delivery options rate adjustments type add to rate',
    defaultMessage: 'Charge more',
    id: 'LFIJfi',
  },
  adjustmentDeductFromRate: {
    description: 'delivery options rate adjustments type deduct from rate',
    defaultMessage: 'Charge less',
    id: 'VHBdLe',
  },
  percentageOfCarrierRateValue: {
    description: 'checkout rates rate adjustments a percent of carrier rate dropdown option',
    defaultMessage: 'Percentage of carrier rate',
    id: 'zMYb5G',
  },
  setAmountValue: {
    description: 'checkout rates rate adjustments a flat rate dropdown option',
    defaultMessage: 'Set Amount',
    id: '0zcZxd',
  },
  percentageOfCarrierRate: {
    description: 'checkout rates rate adjustments a percent of carrier rate',
    defaultMessage: 'Percentage',
    id: 'ohtcuK',
  },
  setAmount: {
    description: 'checkout rates rate adjustments a flat rate',
    defaultMessage: 'Set Amount',
    id: 'KPJFHA',
  },
  adjustBy: {
    description: 'checkout rates rate adjustments increase by',
    defaultMessage: '{additionalFeesMode, select, add {Increase} subtract {Decrease} other {Decrease}} by a',
    id: 'ijk7WX',
  },
  aPercentageOfCarrierRateExplanation: {
    description: 'delivery options rate adjustments a percent of carrier rate added explanation',
    defaultMessage:
      'Calculated based on the rate returned from the carrier. This amount is {additionalFeesMode, select, add {added} subtract {deducted} other {added}} so that the shipping cost appears as a single line item.',
    id: 'SByCYQ',
  },
  aFlatRateExplanation: {
    description: 'delivery options rate adjustments a flat rate added explanation',
    defaultMessage:
      'A flat fee is {additionalFeesMode, select, add {added to} subtract {deducted from} other {added to}} the shipping cost and appears as a single line item.',
    id: 'wXXcvC',
  },
  ifRatesUnavailableTitle: {
    description: 'delivery options rates unavailable title',
    defaultMessage: '3. What to do if Rates are Unavailable',
    id: 'l5OMhe',
  },
  ifRatesUnavailable: {
    description: 'checkout rates unavailable',
    defaultMessage: 'If Rate is Unavailable',
    id: 'adyWBC',
  },
  required: {
    description: 'Required notification',
    defaultMessage: '(Required)',
    id: 'jKgs75',
  },
  selectAction: {
    description: 'delivery options rates unavailable select action',
    defaultMessage: 'Select Option',
    id: 'Kv19PT',
  },
  enterAFlatRate: {
    description: 'delivery options rates unavailable show flat rate',
    defaultMessage: 'Enter a Flat Rate',
    id: 'PIJC2P',
  },
  enterAPercentageOfCart: {
    description: 'delivery options rates unavailable show percent of cart',
    defaultMessage: 'Enter a Percentage of Cart',
    id: 'hg6iby',
  },
  howCalculated: {
    description: 'delivery options rates unavailable how is cart percent calculated',
    defaultMessage: 'How is this calculated?',
    id: '+G06Ut',
  },
  howCalculatedExplanation: {
    description: 'delivery options rates unavailable how is cart percent calculated explanation',
    defaultMessage:
      "If rates can't be displayed, we will use this fallback option. To calculate, we multiply the pre-tax cart total by the percentage you entered.",
    id: 'MYiH8u',
  },
  editOptionCancel: {
    description: 'delivery options edit option cancel button',
    defaultMessage: 'Cancel',
    id: 'AyUI3w',
  },
  editOptionSaveRate: {
    description: 'delivery options edit option save button',
    defaultMessage: 'Save Rate',
    id: 'TjUewK',
  },
  activeAndVisibleCheckbox: {
    description: 'checkout rates active checkbox',
    defaultMessage: 'Rate active and visible in marketplace',
    id: 'dlI8lR',
  },
  adjustPercentageDescription: {
    description: 'checkout rates adjust Percentage description',
    defaultMessage: '(Carrier Rate {additionalFeesMode, select, add {+} subtract {-} other {-}} Percentage = Rate the customer sees)',
    id: 'tXfp+S',
  },
  adjustSetAmountDescription: {
    description: 'checkout rates adjust set amount description',
    defaultMessage: '(Carrier Rate {additionalFeesMode, select, add {+} subtract {-} other {-}} Set Amount = Rate the customer sees)',
    id: '52mkvL',
  },
  couldNotReachService: {
    description: 'delivery options active checkbox',
    defaultMessage: 'Could not reach service',
    id: 'k9Xnrl',
  },
  couldNotRegisterWithMarketplace: {
    description: 'delivery options active checkbox',
    defaultMessage: 'Could not register with marketplace',
    id: '4FTG0P',
  },
  couldNotRetrieveStoreInfo: {
    description: 'delivery options active checkbox',
    defaultMessage: 'Could not retrieve store/marketplace information',
    id: '0ThjOt',
  },
  marketplaceNotSupported: {
    description: 'delivery options active checkbox',
    defaultMessage: 'Marketplace not supported',
    id: '+c5Mbv',
  },
  successfulRequest: {
    description: 'delivery options active checkbox',
    defaultMessage: 'Successful request',
    id: 'zUQC42',
  },
  shopifyChangesTitleCR: {
    description: 'checkout rates shopify changes title',
    defaultMessage: 'You need to make changes to your Shopify account to become eligible for Checkout Rates.',
    id: 'QWzQF6',
  },
  shopifyChangesList: {
    description: 'delivery options shopify changes list',
    defaultMessage: 'Shopify asks that you do one of the following to gain access:',
    id: 'nJA4wb',
  },
  upgradeShopifyPlan: {
    description: 'delivery options upgrade shopify plan',
    defaultMessage: '<a>Upgrade your Shopify plan</a> to a Shopify Advanced plan or higher.',
    id: '3TNeBy',
  },
  addCarrierServices: {
    description: 'delivery options active checkbox',
    defaultMessage: '<a>Add carrier services</a> to Shopify for an additional fee charged by Shopify.',
    id: 'a0Wg/H',
  },
  checkoutRatesExplanation: {
    description: 'checkout rates page explanation',
    defaultMessage:
      'The Checkout Rates feature lets you control what services and rates your customers can select during checkout from your store. To calculate rates, this feature uses:',
    id: 'gYLU7L',
  },
  checkoutRatesProductWeights: {
    description: 'checkout rates page explanation',
    defaultMessage: 'The product weights provided by {marketplaceName}',
    id: 'YLVY8b',
  },
  fulfillmentRatesProductWeights: {
    description: 'fulfillment rates page product weight explanation',
    defaultMessage: 'The product Weight and Dimensions, defined by you in the Products page.',
    id: 'm2P6cy',
  },
  checkoutRatesWarehouse: {
    description: 'checkout rates page explanation',
    defaultMessage: 'Your ShipStation default Ship From Location: {defaultWarehouseName}',
    id: 'YoW1mD',
  },
  productDimensions: {
    description: 'checkout rates page explanation',
    defaultMessage: 'The product dimensions set in the product catalog',
    id: 'E7cFHi',
  },
  betaFeature: {
    description: 'delivery options beta feature explanation',
    defaultMessage: 'This feature is currently in beta.',
    id: 'YQ8hZu',
  },
  checkoutRatesHeader: {
    description: 'checkout rates list header',
    defaultMessage: 'Checkout Rate Displays',
    id: 'W0N5V7',
  },
  addCheckoutRate: {
    description: 'checkout rate add option button',
    defaultMessage: 'Add Checkout Rate',
    id: 'InK3Z2',
  },
  previewDeliveryOptionButton: {
    description: 'delivery options preview button',
    defaultMessage: 'Preview',
    id: '74matS',
  },
  wooCommerceVersionNotSupported: {
    description: 'banner message for WooCommerce stores that do not support checkout rates',
    defaultMessage:
      'Your WooCommerce plugin version does not support Checkout Rates. Please upgrade to the latest version of the ShipStation WooCommerce plugin.',
    id: 'ZZ1CJ/',
  },
  incompatibleMagentoVersionTitleCR: {
    description: 'banner title for incompatible magento plugin version checkout rates',
    defaultMessage: 'The version of the ShipStation plugin installed on your Magento store does not support Checkout Rates.',
    id: 'XQrDL4',
  },
  incompatibleMagentoVersionBodyCR: {
    description: 'banner body text for incompatible magento plugin version checkout rates',
    defaultMessage:
      'Please update to the latest version of the plugin available in the <a>Magento Marketplace</a>. Checkout Rates is supported for Magento version 2.3.4 and higher.',
    id: 'g3BAHs',
  },
  setupShipFromsCR: {
    description: 'banner message to set up ship froms before checkout rates',
    defaultMessage: 'To configure Checkout Rates, you must first set up a default <link>Ship From Location</link>',
    id: 'd2fvgH',
  },
  addShipFromSuccessMessageTitle: {
    description: 'Add ship from success notification message title',
    defaultMessage: 'Ship From Location Successfully Added',
    id: 'kEn78L',
  },
  addShipFromErrorMessageTitle: {
    description: 'Add ship from error notification message title',
    defaultMessage: 'Unable to add Ship From Location, please try again',
    id: 'eAYXV6',
  },
  haventConnectedMarketplaceTitle: {
    description: "delivery options haven't connected marketplace title",
    defaultMessage: "You Haven't Connected to {marketplaceName} Yet",
    id: 'FoY51n',
  },
  haventConnectedMarketplaceExplanationCR: {
    description: "checkout rates haven't connected marketplace explanation",
    defaultMessage: 'Connect ShipStation to your {marketplaceName} account to start setting up Checkout Rates.',
    id: 'izZ+6t',
  },
  connectToMarketplaceButton: {
    description: 'delivery options connect to marketplaces button',
    defaultMessage: 'Connect to {marketplaceName}',
    id: 'xDuYlu',
  },
  haventAddedCheckoutRates: {
    description: 'checkout rates no added rates explanation',
    defaultMessage: 'There are currently no Checkout Rate Displays. Begin by creating a Checkout Rate Display <a>here</a>.',
    id: 'Kg64Bm',
  },
  copyAppend: {
    description: 'delivery options copy appended option name',
    defaultMessage: '{name} (copy)',
    id: 'P5G0r+',
  },
  checkoutRates: {
    description: 'checkout rates settings title',
    defaultMessage: 'Checkout Rates',
    id: '74bKII',
  },
  showAdvancedPreview: {
    description: 'delivery options show advanced preview',
    defaultMessage: 'Show Advanced Preview',
    id: 'mAvqK+',
  },
  residential: {
    description: 'delivery options residential address',
    defaultMessage: 'Residential',
    id: 'lV+H1f',
  },
  commercial: {
    description: 'delivery options commercial address',
    defaultMessage: 'Commercial',
    id: 'pc5meg',
  },
  addressDesignation: {
    description: 'delivery options Address Designation',
    defaultMessage: 'Address Designation',
    id: 'av2ixU',
  },
  previewModalTitleCR: {
    description: 'Preview Checkout Rate Modal Title',
    defaultMessage: 'Preview Checkout Rates - {marketplaceName}',
    id: 'h+NlrF',
  },
  freeShippingFallbackWarning: {
    description: 'free shipping as fallback rate warning for checkout rates',
    defaultMessage: 'You will be providing Free Shipping as your fallback rate',
    id: '0wTr4p',
  },
  servicesMustBeUnique: {
    description: 'selected shipping services must be unique error message',
    defaultMessage: 'Shipping Services must be unique',
    id: 'paV0oV',
  },
  nameIsRequired: {
    description: 'name is required error message',
    defaultMessage: 'Name is a required field',
    id: 'FWfttU',
  },
  serviceNameIsRequired: {
    description: 'name is required error message',
    defaultMessage: 'Service Name is a required field',
    id: 'rcOsmL',
  },
  maximum50Characters: {
    description: 'maximum of 50 characters in name message',
    defaultMessage: 'Maximum 50 characters',
    id: '1a2MhD',
  },
  maximum50CharactersWithRemaining: {
    description: 'maximum of 50 characters including number of characters remaining message',
    defaultMessage: 'Maximum 50 characters ({remaining} remaining)',
    id: 'K+FS3+',
  },
  maximum50CharactersWithOverage: {
    description: 'maximum of 50 characters including number of characters over message',
    defaultMessage: 'Maximum 50 characters ({overage} over)',
    id: 'UilBlI',
  },
  maximum100Characters: {
    description: 'maximum of 100 characters in description message',
    defaultMessage: 'Maximum 100 characters',
    id: 'kWF2pg',
  },
  maximum100CharactersWithRemaining: {
    description: 'maximum of 100 characters including number of characters remaining message',
    defaultMessage: 'Maximum 100 characters ({remaining} remaining)',
    id: 'IKW6ed',
  },
  maximum100CharactersWithOverage: {
    description: 'maximum of 100 characters including number of characters over message',
    defaultMessage: 'Maximum 100 characters ({overage} over)',
    id: 'CMb0uf',
  },
  selectAtLeastOneService: {
    description: 'select at least one service message',
    defaultMessage: 'Select at least one service',
    id: 'Nnk9QQ',
  },
  noZeroValues: {
    description: 'All backup item dimensions must be greater than 0 message',
    defaultMessage: 'All Backup Item values must be greater than 0',
    id: 'dLoB6h',
  },
  setCheckoutRatesServiceOnImport: {
    description: 'label for store setting checkox to override service with checkout rate service on order import',
    defaultMessage: 'On order import, automatically set the Shipping Service selected by the customer at checkout',
    id: '1E5BOG',
  },
  checkoutRatesServiceOnImportNote: {
    description: 'store setting checkbox to override service note',
    defaultMessage: 'NOTE: This will override any <a>service mappings</a> you have already set.',
    id: 'is6f16',
  },
  invalidCompanyNameError: {
    defaultMessage: 'Invalid Company Name',
    id: 'VNP9Pn',
    description: 'store name had invalid content',
  },
  invalidPhoneError: {
    defaultMessage: 'Invalid Phone',
    id: '7f9cXH',
    description: 'phone had invalid characters',
  },
  invalidEmailError: {
    defaultMessage: 'Invalid Email',
    id: 'n8G+em',
    description: 'email had an invalid format',
  },
  pudo: {
    defaultMessage: 'Pickup and Drop off',
    id: '90AH13',
    description: 'pickup drop off rate type',
  },
  pudoDescription: {
    description: 'pickup drop off rate description',
    defaultMessage: 'Ship to a location where the customer can pick up their items.',
    id: 'JR3rgE',
  },
  pudoFreeTitle: {
    defaultMessage: 'Configure Free Delivery',
    id: 'nHV4oo',
    description: 'pickup drop off free delivery title',
  },
  pudoFreeDescription: {
    defaultMessage:
      'Add amount for total order cost over which the shipping will not be charged. If the configuration is not set, free delivery will not be applied. Currency from the storefront will be used for checking total order cost.',
    id: 'iFlRO7',
    description: 'pickup drop off free delivery description',
  },
  defaultDimensionsTitle: {
    defaultMessage: 'Backup Item Dimensions',
    id: 'pT5hmg',
    description: 'Title for live rate default dimensions section',
  },
  defaultDimensionsModalTitle: {
    defaultMessage: 'Add Backup Dimensions',
    id: 'rZyxoY',
    description: 'Title for back up item dimensions modal',
  },
  updateDims: {
    defaultMessage: 'Update',
    id: 'QFYN87',
    description: 'Update button for updating the back up dimensions locally',
  },
  dimensionsModalSubTitle: {
    defaultMessage: 'Dimension Ranges',
    id: 'Evyybq',
    description: 'Sub title for back up item dimensions modal',
  },
  defaultDimensionsInfo: {
    defaultMessage:
      'To ensure you receive rates, set the backup dimensions you wish to use if your items do not have dimensions set in their product details.',
    id: 'Rtyq0M',
    description: 'Information to let the user know what the default item dimensions are used for',
  },
  defaultDimensionsModalInfo: {
    defaultMessage: 'You can set a variety of ranges to accomodate different package weights.',
    id: 'IMd/Ml',
    description: 'Information about back up item ranges in modal',
  },
  binPackingDisabled: {
    defaultMessage: 'Bin Packing is disabled',
    id: 'dnej0z',
    description: 'message to user to let them know that the bin packing feature cannot be used yet',
  },
  learnMore: {
    defaultMessage: 'Learn more',
    id: 'IUsxx3',
    description: 'button to learn about bin packing',
  },
  howToGetBinPacking: {
    defaultMessage: 'Learn more about <link> Live Rates </link>',
    id: 'M7S68c',
    description: 'button to learn about bin packing',
  },
  errorLoadingDeliveryOptionsTitle: {
    defaultMessage: 'Error loading delivery options',
    id: 'FG6w/p',
    description: 'Error message when delivery options cannot be loaded',
  },
  errorLoadingDeliveryOptionsMessage: {
    defaultMessage: 'Delivery options could not be loaded at this time, please try again later.',
    id: 'pY5xc8',
    description: 'Error message when delivery options cannot be loaded',
  },
  errorSavingDeliveryOptionsTitle: {
    defaultMessage: 'Error saving delivery options',
    id: 'IIpfwQ',
    description: 'Error message when delivery options cannot be loaded',
  },
  errorSavingDeliveryOptionsMessage: {
    defaultMessage: "You're changes could not be saved at this time, please try again later.",
    id: 'CpKjIE',
    description: 'Error message when delivery options cannot be loaded',
  },
  fulfilmentRatesTab: {
    description: 'Tab name for the Store Setup Page for managing Fulfillment Rates',
    defaultMessage: 'Fulfillment Rates',
    id: 'n5+9Wv',
  },
  defineFulfillmentRateTitle: {
    description: 'Define Fulfillment Rate Page Title',
    defaultMessage: 'Define Fulfillment Rate',
    id: 'KWQtWP',
  },
  defineFulfillmentRateDescription: {
    description: 'Define Fulfillment Rate Page Title',
    defaultMessage: 'Define the pricing, service name, and delivery speed merchants see for this rate when delegating orders to you.',
    id: 'fGr54l',
  },
  calculatedRate: {
    description: 'fulfillment rates calculated rate method',
    defaultMessage: 'Calculated Rate',
    id: '4GYgux',
  },
  noChargeRate: {
    description: 'fulfillment rates no charge method',
    defaultMessage: 'No Charge',
    id: '73DJrP',
  },
  calculatedRateDescription: {
    description: 'fulfillment rates calculated rate description',
    defaultMessage: 'Calculate rates per order, based on ShipStation Carrier Services rates.',
    id: 'v4EH9X',
  },
  noChargeRateDescription: {
    description: 'fulfillment rates no charge description',
    defaultMessage: "Don't charge merchants when they use this rate.",
    id: 'fsBgv0',
  },
  fulfillmentRatesExplanation: {
    description: 'fulfillment rates page explanation',
    defaultMessage:
      'Fulfillment Rates let you define what fulfillment services you make available to this connected merchant, and how much they cost.',
    id: 'kKfzcL',
  },
  fulfillmentRatesCalculation: {
    description: 'start of list what is included in the fulfillment rates calculation',
    defaultMessage: 'To calculate rates, Fulfillment Rates uses:',
    id: 'mSv/o+',
  },
  recipientAddress: {
    description: 'fulfillment rates page explanation',
    defaultMessage: 'The Ship To Address of order you receive from this merchant.',
    id: 'BTQBDQ',
  },
  fulfillmentRatesHeader: {
    description: 'fulfillment rates list header',
    defaultMessage: 'Rates',
    id: '4zzOTI',
  },
  addFulfillmentRate: {
    description: 'checkout rate add option button',
    defaultMessage: 'Add Fulfillment Rate',
    id: 'EKrMXb',
  },
  fulfillmentRates: {
    description: 'fulfillment rates settings title',
    defaultMessage: 'Fulfillment Rates',
    id: 'uoLlQp',
  },
  haventAddedFulfillmentRates: {
    description: 'no fulfillment rates have been created yet, gives user a link to add one.',
    defaultMessage: 'There are currently no Fulfillment Rates. Begin by creating one <a>here</a>.',
    id: 'Gbdg/t',
  },
  fulfillmentRatesServiceLevel: {
    description: 'fulfillment rates Service Level input label',
    defaultMessage: 'Service Level',
    id: 'aeMxc6',
  },
  fulfillmentRateAdjustmentsExplanation: {
    description: 'delivery options fulfillment rate adjustments explanation',
    defaultMessage: 'Mark rates up or down by a percentage or fixed amount. Useful for including cost of packaging and handling.',
    id: 'XFGYvQ',
  },
  activeAndVisibleFulfillmentCheckbox: {
    description: 'checkout rates active checkbox',
    defaultMessage: 'Rate active and visible to delegating merchants',
    id: 'Kr5KV7',
  },
  fulfillmentAdjustPercentageDescription: {
    description: 'checkout rates adjust Percentage description',
    defaultMessage: '(Carrier Rate {additionalFeesMode, select, add {+} subtract {-} other {-}} Percentage = Rate the merchant sees)',
    id: 'PrA2ST',
  },
  fulfillmentAdjustSetAmountDescription: {
    description: 'checkout rates adjust set amount description',
    defaultMessage: '(Carrier Rate {additionalFeesMode, select, add {+} subtract {-} other {-}} Set Amount = Rate the merchant sees)',
    id: 'aJaltU',
  },
  carrierRateSubtitle: {
    description: 'carrier rate subtitle explaining how the rate is calculated',
    defaultMessage: 'The ShipStation Carrier Service used to calculate rates.',
    id: 'ZbuxJy',
  },
  simpleCalcMethod: {
    description: 'Radio button title for simple by volume calculation method',
    defaultMessage: 'By Volume',
    id: 'NLnR3u',
  },
  binPackingCalcMethod: {
    description: 'Radio button title for bin packing calculation method',
    defaultMessage: 'Cartonization',
    id: 'O/hQt7',
  },
  byWeightCalcMethod: {
    description: 'Radio button title for by weight calculation method',
    defaultMessage: 'By Weight',
    id: 'hioMmE',
  },
  calcMethodTitle: {
    description: 'title for Calculation Method section',
    defaultMessage: 'Calculation Method',
    id: '5V2zmN',
  },
  byVolumeDescription: {
    description: 'description for by volume calculation method',
    defaultMessage: 'Rates based on both weight and dimensions',
    id: 'DfR7Q0',
  },
  byWeightDescription: {
    description: 'description for by weight calculation method',
    defaultMessage: 'Rates based on shipment weight only',
    id: 'OPM6OL',
  },
  binPackingDescription: {
    description: 'description for the bin packing calculation method',
    defaultMessage: 'By volume rates that use your custom packaging',
    id: 'yLjdZ4',
  },
  startingWeightKG: {
    description: 'starting weight of weight breakpoint based on stopping weight of previous breakpoint in kilogram and  gram units',
    defaultMessage: '{firstValue} kg, {secondValue} g ',
    id: 'Ont6W4',
  },
  startingWeightLB: {
    description: 'starting weight of weight breakpoint based on stopping weight of previous breakpoint in pounds and ounces units',
    defaultMessage: '{firstValue} lb, {secondValue} oz ',
    id: 'zFfEuD',
  },
  andAbove: {
    description: 'last weight breakpoint section, everything above a certain weight',
    defaultMessage: 'Above',
    id: 'ifArqx',
  },
  weightError: {
    description: 'displays an error to user if weight value is not greater than previous value',
    defaultMessage: '(To) value must be greater than (From) value.',
    id: 'IecG3t',
  },
  dimensionError: {
    description: 'displays an error to user if dimension values are not greater than zero',
    defaultMessage: 'Dimension values must be greater than 0',
    id: 'KlDIGC',
  },
  lowRangeTitle: {
    description: 'Weight range title for lowest range',
    defaultMessage: 'Lowest Range',
    id: 'K/a2oq',
  },
  highRangeTitle: {
    description: 'Weight range title for highest range',
    defaultMessage: 'Highest Range',
    id: 'BeqGsZ',
  },
  rangeDeleteButton: {
    description: 'Button to delete weight range for default dimensions',
    defaultMessage: 'Delete Breakpoint Range',
    id: 'oM8cb3',
  },
  rangeStart: {
    description: 'Weight range start title',
    defaultMessage: 'From',
    id: 'zI08vN',
  },
  rangeStop: {
    description: 'weight range stop title',
    defaultMessage: 'To',
    id: '91z4nP',
  },
  itemDimensions: {
    description: 'item dimensions title',
    defaultMessage: 'Set package dimensions to',
    id: 'rJ1YZu',
  },
  addBreakpointButton: {
    description: 'Button to add weight breakpoint',
    defaultMessage: 'Add Breakpoint Range',
    id: 'bWSAQQ',
  },
  betaTag: {
    description: 'Beta tag',
    defaultMessage: 'Beta',
    id: 'fBcUq1',
  },
  selectFulfillmentService: {
    defaultMessage: 'Select a Fulfillment Service',
    description: 'fulfillment rates select fulfillment service dropdown placeholder',
    id: 'gyKVhv',
  },
  flatRateValueMustBePositive: {
    defaultMessage: 'Flat Rate Price must be a positive number',
    description: 'flat rate value must be a positive number',
    id: 'FeDElG',
  },
  flatRateValueIsRequired: {
    defaultMessage: 'Flat Rate Price is required',
    description: 'flat rate price is required',
    id: 'tJy53c',
  },
  fallbackModeValueIsRequired: {
    defaultMessage: 'Backup Rate option is required',
    id: 'IuM9aF',
    description: 'fallback option is required',
  },
  calcMethodSectionTitle: {
    defaultMessage: 'Live Rate Calculation Method',
    description: 'Title for calculation method section',
    id: '2nUIVv',
  },
  calcMethodSectionInfo: {
    defaultMessage: 'Choose how your selected services will calculate rates. Learn more about <link> Live Rates </link>',
    description: 'Info for calculation method section',
    id: 'giwUQn',
  },
  calcMethodList1: {
    defaultMessage: 'Your default Ship From Location: {name}',
    description: 'bulleted list item in calculation info section',
    id: 'QDBpDE',
  },
  calcMethodList2: {
    defaultMessage: 'The product dimensions set in the <link>product catalog </link>',
    description: 'bulleted list item in calculation info section',
    id: 'rc/+Bu',
  },
  backupRateTitle: {
    defaultMessage: 'Backup Rate',
    description: 'Title for fallback rate section',
    id: 'yOAQc1',
  },
  backupRateInfo: {
    defaultMessage: 'Sometimes a rate cannot be pulled from a carrier. When this happens, select how you want it to be handled.',
    description: 'Info for fallback rate section',
    id: '5QP9dC',
  },
  sharedSettingsInfo: {
    defaultMessage: 'These settings are shared by all live rates configured for this store',
    description: 'Info banner message to inform user of shared settings',
    id: 'B1ZQ4H',
  },
  enableCartonization: {
    defaultMessage: 'Enable Cartonization',
    id: '5Orv9H',
    description: 'Interactable popover title',
  },
  disabledMessage: {
    defaultMessage: 'To enable cartonization, add custom packages',
    id: '/VgSCd',
    description: 'Interactable popover info',
  },
  setupPackages: {
    defaultMessage: 'Add Packages',
    id: 'Pq1jAF',
    description: 'Button text for taking user to custom package page',
  },
  viewMore: {
    defaultMessage: 'Click to view more',
    id: 'ViBx0t',
    description: 'popover tooltip view more message',
  },
  deactivedNoService: {
    defaultMessage:
      'The services set for this Checkout Rate are no longer active. You must select new services before you can save this Checkout Rate.',
    id: 'i8e2zZ',
    description: 'Banner message to inform user one or more services in checkout rate have been disabled and they must choose new services',
  },
  deactivedHasOtherServicesService: {
    defaultMessage:
      'This Checkout Rate includes both active and inactive services. Once you save your new configuration, the deactivated services will be removed from this Checkout Rate.',
    id: '2MGrrR',
    description: 'Banner message to inform user one or more services in checkout rate have been disabled',
  },

  addDimensions: {
    defaultMessage: '+ Add Dimensions',
    id: 'hucMo4',
    description: 'Button text to open back up dimensions modal',
  },
  addRange: {
    defaultMessage: '+ Add a Range',
    id: 'vBY8Yv',
    description: 'Button text to add a new range',
  },
  editRange: {
    defaultMessage: 'Edit',
    id: 'BedIa3',
    description: 'Button text to edit a range',
  },
  readOnlyDims: {
    defaultMessage: '{length}(L), {width}(W), {height}(H) {unit}',
    id: 'T4vwOW',
    description: 'read only values for backup dimensions',
  },
  continue: {
    defaultMessage: 'Continue',
    id: '/bRye8',
    description: 'Button in confirmation modal to continue with cancelation',
  },
  confirmHeader: {
    defaultMessage: 'Close Backup Dimensions',
    id: 'S4p4na',
    description: 'Confirmation modal header for cancelling back up item update',
  },
  confirmBody: {
    defaultMessage:
      'Your recent changes have not been saved. Choose <b>Cancel</b> to go back and save your changes, or <b>Continue</b> to close without saving your changes.',
    id: 'jFNbXm',
    description: 'Confirmation modal body for cancelling back up item update',
  },
  emailVerificationRequired: {
    defaultMessage: 'To modify this setting, check your email and follow the account verification instructions',
    id: 'yNKtCx',
    description: 'tooltip message for when user needs to verify their email to modify a setting',
  },
  bccAddButton: {
    description: 'Button to add an email address to the BCC list on the Notifications tab',
    defaultMessage: 'Add',
    id: 'oh2ifR',
  },
  bccRemoveEmail: {
    description: 'Aria label for the button that removes an email address from the BCC list',
    defaultMessage: 'Remove {email} from BCC list',
    id: 'BZ35sk',
  },
  bccInfoTooltip: {
    description: 'Tooltip shown next to the BCC Email Address label explaining what it applies to',
    defaultMessage: 'Applies to any enabled email notification above',
    id: 'PXs8Uq',
  },
  bccEmailInputPlaceholder: {
    description: 'Placeholder text for the BCC email address input on the Notifications tab',
    defaultMessage: 'Enter email address',
    id: 'wCcFRY',
  },
  bccMaxLengthError: {
    description: 'Error shown when adding another BCC email address would exceed the maximum stored length',
    defaultMessage: 'Cannot add address: BCC list has reached its maximum length',
    id: 'I7isjT',
  },
  bccDuplicateEmailError: {
    description: 'Error shown when the entered BCC email address is already in the list',
    defaultMessage: 'This email address has already been added',
    id: '9TFuhq',
  },
});
